import api from "@core/api/api";

/**
 * Admin Settings Service
 * System configuration and settings management
 */

const SETTINGS_BASE_URL = "/admin/settings";

export const adminSettingsService = {
  /**
   * Get all system settings
   * @returns {Promise} Settings data
   */
  async getSettings() {
    const response = await api.get(SETTINGS_BASE_URL);
    return response.data;
  },

  /**
   * Update system settings
   * @param {Object} data - Settings data
   * @returns {Promise} Update result
   */
  async updateSettings(data) {
    const response = await api.put(SETTINGS_BASE_URL, data);
    return response.data;
  },

  /**
   * Get specific category settings
   * @param {string} category - Settings category
   * @returns {Promise} Category settings
   */
  async getCategorySettings(category) {
    const response = await api.get(`${SETTINGS_BASE_URL}/${category}`);
    return response.data;
  },

  /**
   * Reset settings to default
   * @param {string} category - Settings category to reset
   * @returns {Promise} Reset result
   */
  async resetSettings(category) {
    const response = await api.post(`${SETTINGS_BASE_URL}/reset`, { category });
    return response.data;
  },
};
